import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { FooterComponent } from './footer';

@NgModule({
  declarations: [
    FooterComponent,
  ],
  imports: [
    IonicModule,
  ],
  exports: [
    FooterComponent
  ]
})
export class FooterComponentModule {}



// WEBPACK FOOTER //
// ./src/components/footer/footer.module.ts